<template>
	<meta/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters('user', ['getActiveCustomer', 'getActiveCompany'])
	},

	watch: {
		'getActiveCustomer'(to, from) {
			if (to?.id && to?.id !== from?.id) {
				this.fetchActiveCustomer(to.id, to.companyId);
			}
		}
	},

	created() {
		this.$bus.$on('active-customer:fetch', this.handler);
	},

	destroyed() {
		this.$bus.$off('active-customer:fetch', this.handler);
	},

	methods: {
		...mapActions('user', ['setActiveCustomer']),

		handler() {
			this.fetchActiveCustomer(this.getActiveCustomer.id, this.getActiveCustomer.companyId);
		},

		async fetchActiveCustomer(customerId, companyId) {
			const data = await this.$services.customer.getActiveCustomer({
				customerId,
				companyId: companyId ?? this.getActiveCompany.id
			});

			this.setActiveCustomer({ ...data, customerId });
		}
	}
};
</script>
